interface StatCardProps {
  icon: React.ReactNode;
  value: string;
  label: string;
  trend: number;
  iconBg: string;
}

export const StatCard = ({ icon, value, label, trend, iconBg }: StatCardProps) => {
  const isPositive = trend > 0;
  
  return (
    <div className="flex-1 p-5 bg-white rounded-[10px] outline outline-1 outline-offset-[-1px] outline-zinc-200 flex justify-start items-start gap-3 transition-all duration-200 ease-in-out hover:transform hover:-translate-y-1 hover:shadow-lg cursor-pointer">
      {/* Icône avec fond coloré - Structure exacte Figma */}
      <div className={`p-2.5 ${iconBg} rounded-xl inline-flex flex-col justify-start items-start gap-2.5 overflow-hidden`}>
        <div className="relative">
          {icon}
        </div>
      </div>
      
      {/* Contenu texte */}
      <div className="flex-1 inline-flex flex-col justify-start items-start gap-1">
        {/* Ligne avec valeur et pourcentage */}
        <div className="self-stretch inline-flex justify-between items-center">
          <div className="justify-start text-gray-800 text-2xl font-semibold font-['Bricolage_Grotesque'] tracking-tight">
            {value}
          </div>
          <div className={`px-1.5 py-1 rounded-full flex justify-center items-center gap-2.5 ${
            isPositive ? 'bg-green-500/10' : 'bg-red-500/10'
          }`}>
            <div className={`justify-start text-xs font-medium font-['Bricolage_Grotesque'] capitalize tracking-tight ${
              isPositive ? 'text-green-500' : 'text-red-500'
            }`}>
              {isPositive ? '+' : ''}{trend}%
            </div>
          </div>
        </div>
        
        {/* Label */}
        <div className="justify-start text-neutral-400 text-xs font-medium font-['Bricolage_Grotesque'] capitalize tracking-tight">
          {label}
        </div>
      </div>
    </div>
  );
};